module.exports = __webpack_public_path__ + "img/7.98d6ba2a.jpg";